
var liSimply = {
  shopid:6,
  interface:"https://ectappv2.eatcaketoday.com/interfaceStore",
  actions:{
    getProductData:"getProductData",
    checkLineItems:"checkLineItems"
  }
};


//var currentindex = ;

//var current_cart_row = 1;

var store_start_time_week = 9;
var store_start_time_weekend = 9;
var store_end_time_week = 21;
var store_end_time_weekend = 18;
var vendor_last_order_time = 16;
var vendor_last_order_time_sameday = 21;

var $vendorDates_div = $("#vendorDates_div");
var $vendorDates_input = $("#vendorDates_input");
var variantSelect = "#productSelect-option-0";
var datePickerLoading = "#datePickerLoading";
var productForm = "#productAddToCartForm";
var quantity = "#quantity";
var $timing = $("#timing");

window.vendorPluginInitialize = function(){
  getData();
  addHoverEvent();
  addClickEvent();
}

$(document).ready(function(){

});
function getData(){
  $.post(liSimply.interface,{
    shopid:liSimply.shopid,
    action:liSimply.actions.getProductData,
    productId:product.id
  },function(dataObject){
    $(datePickerLoading).addClass("hidden");
    $(productForm).removeClass("hidden");

    var data = $.parseJSON(dataObject);
    if(data.status=="0"){
      window.product_db = data.product;
      setInitialData();
      setDetails();
    }
    else{

    }
  });
}


function setInitialData(){
  window.unAvailabelVariantsTitle = [];
  window.availabelVariantsTitle = []; 
  window.variantsTitle = [];
  $.each(window.product_db.variants,function(index,item){
    var date = index;
    var capacity = item.capacity;
    var quantity = 0;
    var order_quantity = item.order_quantity;    
    var checkout_quantity = item.checkout_quantity;
    if(cn(capacity) || cn(parseInt(capacity)==0)){
      quantity = 0;
    }
    else {
      quantity = parseInt(capacity) - parseInt(order_quantity) - parseInt(checkout_quantity);
    }

    if(quantity<=0){
      window.unAvailabelVariantsTitle.push(date);
    }
    else{
      window.availabelVariantsTitle.push(date);
    }
    window.variantsTitle.push(date);
  });
  setPlugin();
}

window.GMT = 8;

function calcTime(offset) {
  // debugger;
  // var d = new Date();
  // convert to msec
  // subtract local time zone offset
  // get UTC time in msec
  // var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  // create new Date object for different city
  // using supplied offset
  var nd = new Date(simply.getDateSpecial);
  window.current_hrs = nd.getHours();
  window.current_minutes = nd.getMinutes();
  window.current_seconds = nd.getSeconds();


  console.log(window.current_hrs);
  console.log(window.current_minutes);
  console.log(window.current_seconds);
  window.day = nd;

}

calcTime(window.GMT);


function setPlugin(){

  var startdate = variantsTitle[0];
  var parts =startdate.split('-');

  var s_date = new Date(parts[2],parts[1]-1,parts[0]);
  var cur_date = window.day;

  if(s_date.getTime()  < cur_date.getTime() ){
    startdate = cur_date.yyyymmdd();
  }

  $vendorDates_div.datepicker({
    format: "dd-mm-yyyy",
    startDate: startdate,
  });

  $vendorDates_div.on("changeDate", function () {
    var date = $vendorDates_div.datepicker('getFormattedDate');
    $vendorDates_input.val(date);
    if(cn(window.product_db)){

    }
    else{
      setDetails();
    }
  });



  $vendorDates_div.datepicker('setEndDate', variantsTitle[variantsTitle.length-1]);
  $vendorDates_div.datepicker('setDatesDisabled', unAvailabelVariantsTitle);
  $vendorDates_div.datepicker('setDate', availabelVariantsTitle[0]);
}
function addHoverEvent(){
  $(".form_footer .extra_data").hover(function(e){
    e.stopPropagation();
    $(this).find(".know_more").stop().fadeIn();
  },
                                      function(e){
    e.stopPropagation();
    $(this).find(".know_more").stop().fadeOut();
  });
}
function addClickEvent(){
  $(document).hover(function() {
    $(".form_footer .know_more").hide();
  });
  $(".form_footer .know_more .close").click(function(e){
    e.stopPropagation();
    $(".form_footer .know_more").hide();
  });
}

function getStartEnd(date, currentTime, current_minutes, indexRow =""){
  
  console.log("indexRow "+indexRow)
  var current_cart_row = indexRow+1;
  console.log("yess "+current_cart_row)
  
  
  var startendobj = {};
  startendobj.starting = 1;
  startendobj.ending = 1;
  startendobj.qty = 0;
  if(cn(date)){
    return startendobj;
  }
  if(window.product_db.variants[date]){

  }
  else{
    return startendobj;
  }
  var startingTiming = window.product_db.variants[date].startingTime;
  var endingTiming = window.product_db.variants[date].endingTime;
  var backingTime_hr =  window.product_db.variants[date].bakingTime_hr;
  var bakingTime_day =  parseInt(window.product_db.variants[date].bakingTime_day);
  vendor_last_order_time_sameday = vendor_last_order_time = parseInt(window.product_db.lastOrderTime);
  startendobj.vendor_last_order_time = vendor_last_order_time_sameday;

  var s_date = new Date();
  var e_date = new Date();
  var starting_hr = startingTiming.split(":")[0];
  var current_hr = parseInt(currentTime);
  var current_min = parseInt(current_minutes);
  if(current_min > 0){
    current_hr = current_hr+1;
  }
  var cur_date = new Date(simply.getDateSpecial);
  var bToday = false;
  if(date==cur_date.yyyymmdd()){
    bToday = true;
  }

  var item = window.product_db.variants[date];
  var capacity = item.capacity;
  var quantity = 0;
  var order_quantity = item.order_quantity;    
  var checkout_quantity = item.checkout_quantity;
  if(cn(capacity) || cn(parseInt(capacity)==0)){
    quantity = 0;
  }
  else {
    quantity = parseInt(capacity) - parseInt(order_quantity) - parseInt(checkout_quantity);
  }

  if(quantity<=0){
    starting = 1;
    ending =  1 ;
  }
  else{
    var ending_hr = endingTiming.split(":")[0];

    $timing.find(".timingDuration").remove();
    $timing.append("<option class='timingDuration' value='-1' selected>Please select time</option>");

    if(cn(window.product_db.variants[date].bakingTime_day)){
      bakingTime_day = parseInt(window.product_db.bakingTime_day);
    }

    if(cn(backingTime_hr)){ 
      bPass = true;
      bakingTime_day
      if(bakingTime_day == 1){
        var oneDate = new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000);
        if(date==oneDate.yyyymmdd()){
          if(current_hr > vendor_last_order_time ){
            backingTime_hr = 1;
            starting = ending = 0;
            bPass = false;
          }
        }
      }
      if( bakingTime_day == 2 ){
        var oneDate = new Date(new Date().getTime() + 2 * 24 * 60 * 60 * 1000);
        if(date==oneDate.yyyymmdd()){
          if(current_hr > vendor_last_order_time ){
            backingTime_hr = 1;
            starting = ending = 0;
            bPass = false;
          }
        }
      }
      if(bakingTime_day == 3){
        var oneDate = new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000);
        if(date==oneDate.yyyymmdd()){
          if(current_hr > vendor_last_order_time ){
            backingTime_hr = 1;
            starting = ending = 0;
            bPass = false;
          }
        }
      }
      if(bPass){
        backingTime_hr = 1;
        starting = parseInt(starting_hr);
        ending =  parseInt(ending_hr) + 1 ;
      }
    }
    else{  
      if(bToday){ 
        var tag_time = $(".delivery_time_"+current_cart_row).val();
        
        console.log("current_cart_row"+tag_time)
        
        if(tag_time == null || tag_time == '' || tag_time == 'undefined'){
          tag_time = 14;
        }
        else{
          tag_time = parseInt(tag_time);
        }
        

        
        if(parseInt(current_hr) <= tag_time){
          if(vendor_last_order_time_sameday >= parseInt(current_hr)){
            if((parseInt(starting_hr) <= parseInt(current_hr)) && current_min > 0){
              starting_hr = current_hr - 1 ;
              starting = parseInt(starting_hr) + parseInt(backingTime_hr);
              ending = parseInt(ending_hr) + 1 ;
            }
            else if((parseInt(starting_hr) - 3  <= parseInt(current_hr)) && current_min > 0){
              starting_hr = current_hr - 1 ;
              starting = parseInt(starting_hr) + parseInt(backingTime_hr);
              ending = parseInt(ending_hr) + 1 ;
            }
            else{
              if(parseInt(starting_hr) - 3 >= parseInt(current_hr) ){
                starting = parseInt(starting_hr) + 1;
                ending = parseInt(ending_hr) + 1 ;
              }
              else{
                starting = parseInt(starting_hr);
                ending = parseInt(ending_hr) + 1 ;
              }
            }
          }
          else{
            starting = 1;
            ending = 1 ;  
          }

        }
        else{
          console.log("Delivery time is gone");
          starting = 1;
          ending = 1 ;
        }
      }
      else{ 
        starting  =  parseInt(starting_hr);
        ending = parseInt(ending_hr) + 1;
      }
    }

    var parts =date.split('-');

    var d = new Date(parts[2],parts[1]-1,parts[0]); 
    var day = d.getDay();
    var isWeekend = (day == 6) || (day == 0);

    if(!isWeekend && ending > store_end_time_week){
      ending = store_end_time_week;
    }

    if(isWeekend && ending > store_end_time_weekend){
      ending = store_end_time_weekend;
    }


    if(!isWeekend && store_start_time_weekend > starting){
      starting = store_start_time_week;
    }

    if(isWeekend && store_start_time_weekend > starting){
      starting = store_start_time_weekend;
    }

  }
  
 //if(indexRow == false) { 
 // ++current_cart_row
// }

  startendobj.starting = starting;
  startendobj.ending = ending;
  startendobj.qty = quantity;
  return startendobj;
}
function setDetails(){
  var date = $vendorDates_input.val();
  var startEndObj = getStartEnd(date, window.current_hrs, window.current_minutes);

  $('#quantity').attr('max', startEndObj.qty );
  for(var i = startEndObj.starting;
      i < startEndObj.ending;i=i+2){
    $timing.append("<option class='timingDuration' value='"+i+":00-"+(i+2)+":00'>"+convertTwelve(i)+" - "+convertTwelve(i+2)+"</option>");
  }

  if(startEndObj.starting >= startEndObj.ending){
    var strNotime = "You missed today's last delivery, please choose another date!";
    $timing.append("<option class='timingDuration' value='-1'>"+strNotime+"</option>");
  }
}


function convertTwelve(hour){
  var date_format = '12'; /* FORMAT CAN BE 12 hour (12) OR 24 hour (24)*/
  var minutes = '00'; 
  var result  = hour;
  var ext     = '';

  if(date_format == '12'){
    if(hour > 12){
      ext = 'PM';
      hour = (hour - 12);

      if(hour < 10){
        result = " " + hour;
      }else if(hour == 12){
        hour = "00";
        ext = 'AM';
      }
    }
    else if(hour < 12){
      result = ((hour < 10) ? "0" + hour : hour);
      ext = 'AM';
    }else if(hour == 12){
      ext = 'PM';
    }
  }

  result = result +':'+minutes+''+ext;

  return result;
}



function cn(o){return"undefined"==typeof o||null==o||""==o.toString().trim()}

Date.prototype.yyyymmdd = function() {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  mm = ('0' + mm ).slice(-2);
  var dd = ("0" + this.getDate()).slice(-2);


  return [dd, '-', mm, '-', this.getFullYear()].join(''); // padding
};


$('#addToCartForm').submit(function(e){
  if($('#timing').val() == '-1'){
    e.preventDefault();
    alert('Please choose a valid delivery timing.');
  }
});

$('#specific-instructions-select-box').on('change', function() {
  $('#specific-instructions').val($("#specific-instructions-select-box option:selected").text());
});
